import { useQuery } from '@apollo/client/react';
import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import {
  GET_TOTAL_ARTICLES_FOR_COUNT,
  GET_TOTAL_ARTICLES_FOR_COUNT_BY_TYPE,
} from '../../../../cms/queries/article-queries.gql';

const useGetTotalArticles = (insuranceType?: string) => {
  const query = insuranceType ? GET_TOTAL_ARTICLES_FOR_COUNT_BY_TYPE : GET_TOTAL_ARTICLES_FOR_COUNT;
  const { data, loading, error } = useQuery<ResultOf<typeof query>, VariablesOf<typeof query>>(
    query,
    insuranceType ? { variables: { insuranceType } } : undefined,
  );
  const totalArticles = data?.allArticle?.length || 0;
  return { error, isLoading: loading, totalArticles };
};

export default useGetTotalArticles;
